/**
 * The `<main>` landmark of the page shell. It lives here rather than in
 * `Page.tsx` so client components can target it without pulling that
 * server-only module into the client bundle.
 */
export const MAIN_CONTENT_ID = 'main-content';
